<ion-app>
  @if (emulatorModeActive) {
    <div
      class="fixed z-[9999] bottom-3 right-3 pad-safe-area-bottom flex items-center gap-2 rounded-full border border-outline-high bg-surface-high px-3 py-1.5 shadow-sm pointer-events-none"
      role="status"
      aria-label="Local emulator mode active"
    >
      <span class="h-2 w-2 rounded-full bg-warning"></span>
      <span class="text-xs font-semibold text-body">LOCAL · {{ emulatorProjectId }}</span>
    </div>
  }

  <!-- Blume staff access indicator — renders only for staff-access sessions
       on notebook/* and admin/* routes. Mounted here rather than in the two
       shells because many of those routes are flat siblings of the shells. -->
  <app-staff-access-banner />

  <!-- Global Backdrop -->
  @if (backdrop()) {
  <div class="global-backdrop" [@backdrop] (click)="onBackdropClick()"></div>
  }

  <div class="flex w-full min-h-screen" [inert]="commandPaletteService.isOpen()">
    <!-- Main Content Area -->
    <div class="flex-1 relative">
      <ion-router-outlet [swipeGesture]="false"></ion-router-outlet>

      <!-- Bottom Nav Bar (hidden on some routes, e.g. live workshop) -->
      @if (!hideGlobalNavBar()) {
        <app-global-nav-bar class="lg:hidden"></app-global-nav-bar>
      }
    </div>
  </div>

  <!-- Shared Responsive Modal Backdrop -->
  <app-responsive-modal-backdrop />

  <!-- Global Bottom Sheet -->
  <app-bottom-sheet />

  <!-- Domain-based invitations: the prompt after sign-in -->
  <app-domain-join-prompt />

  <!-- Global Command Palette -->
  <app-command-palette [isOpen]="commandPaletteService.isOpen()" [contentTemplate]="commandPaletteService.content()"
    [placeholder]="commandPaletteService.placeholder()" (close)="closeCommandPalette()"
    (searchChange)="onCommandPaletteSearchChange($event)" />

  <!-- Global Action Dialog -->
  <app-action-dialog [isOpen]="actionDialogVisible()" [title]="actionDialog().title"
    [maxWidth]="actionDialog().maxWidth ?? 700"
    [showCloseButton]="actionDialog().showCloseButton ?? true"
    [showDoneButton]="actionDialog().showDoneButton ?? true"
    [doneButtonText]="actionDialog().doneButtonText ?? 'Done'"
    [doneButtonColor]="actionDialog().doneButtonColor ?? 'purple'" [closeOnBackdropClick]="
      actionDialog().closeOnBackdropClick ?? true
    " [closeOnEscape]="actionDialog().closeOnEscape ?? true"
    [customClass]="actionDialog().customClass" [color]="actionDialog().color ?? 'surface'"
    (close)="closeActionDialog()">
    <ng-container *ngTemplateOutlet="actionDialog().content"></ng-container>
  </app-action-dialog>

  <!-- Global Action Bar -->
  <!-- <app-panel-action-bar /> -->
</ion-app>
